/* @flow */
import { observable, computed } from 'mobx';

import { ApiModel } from 'api/ApiModel';
import type { Region } from 'models/Regions';
import ApiService from 'services/ApiService';
import { Roles } from 'permissions/defs';
import * as reportingPermissions from 'permissions/reporting';

import UserStore from './UserStore';

export default class RegionStore extends ApiModel {
  static REGION_FILTER_KEY = 'region_id';

  @observable regions: { [id: string]: Region } = {};
  @observable regionsLoading = false;

  get allRegionId(): string {
    return 'ALL';
  }

  userStore: UserStore;

  constructor(api: ApiService, userStore: UserStore) {
    super(api);

    this.userStore = userStore;
  }

  @computed get regionOptionsInfo() {
    const { userRoleId, activeUser } = this.userStore;

    let options = Object.values(this.regions);
    let restricted = false;
    let suggestedDefault = this.allRegionId;

    const activeUserRegion: ?Region = activeUser && activeUser.region;

    if (
      typeof userRoleId === 'number' &&
      reportingPermissions.restrictedRegionRoles.includes(userRoleId)
    ) {
      options = Object.values(this.regions).filter(option => option.id === activeUserRegion.id);

      if (options.length) {
        suggestedDefault = options[0].id;
      }

      restricted = true;
    }

    return {
      options,
      restricted,
      suggestedDefault,
    };
  }

  loadRegions = async () => {
    this.regionsLoading = true;

    const regions = await this.api.getResource(`regions`);

    if (regions) {
      this.regions = {
        ALL: { id: 'ALL', name: 'ALL' },
        ...regions.reduce(
          (_regions, region) => ({
            ..._regions,
            [region.id]: region,
          }),
          {}
        ),
      };
    }

    this.regionsLoading = false;
    return regions;
  };
}
